export const CorporateStatusType = {
    ACTIVE:"فعال",
    INACTIVE:"غیر فعال",
    PREREGISTER:"پیش ثبت نام",
    LOW_BUDGET:"کمبود بودجه",
    DEMO:"دمو",
    SECURE_DEMO:"پیش نمایش"
}
